class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimeout = null;
    this.lastHoverOpenTime = 0;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    if (this.summary) {
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  isDesktopHover() {
    return window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
  }

  onMouseEnter() {
    if (!this.isDesktopHover()) return;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.lastHoverOpenTime = Date.now();
      this.mainDetailsToggle.setAttribute('open', '');
      if (this.summary) this.summary.setAttribute('aria-expanded', true);
      this.onToggle();
    }
  }

  onMouseLeave() {
    if (!this.isDesktopHover()) return;
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 180);
  }

  onSummaryClick(event) {
    if (!this.isDesktopHover()) return;
    if (this.mainDetailsToggle.hasAttribute('open') && Date.now() - this.lastHoverOpenTime < 500) {
      event.preventDefault();
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
